var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHangUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 10,
    viewBox: "0 0 28 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7607 5.27088C23.3183 2.00903 18.6682 0 13.544 0C8.41986 0 3.76975 2.00903 0.327314 5.27088C0.124153 5.47404 0 5.75621 0 6.07223C0 6.38826 0.124153 6.67043 0.327314 6.87359L3.12641 9.67269C3.32957 9.87585 3.61174 10 3.92776 10C4.23251 10 4.51467 9.87585 4.71783 9.68397C5.60948 8.84876 6.62528 8.14898 7.72009 7.59594C8.09255 7.41535 8.35214 7.0316 8.35214 6.58013V3.08126C9.98871 2.5395 11.7381 2.25734 13.544 2.25734C15.3499 2.25734 17.0993 2.5395 18.7359 3.06998V6.56885C18.7359 7.00903 18.9955 7.40406 19.3679 7.58465C20.474 8.1377 21.4786 8.84876 22.3815 9.67269C22.5846 9.87585 22.8668 9.98871 23.1716 9.98871C23.4876 9.98871 23.7697 9.86456 23.9729 9.6614L26.772 6.8623C26.9752 6.65914 27.0993 6.37698 27.0993 6.06095C27.0993 5.74492 26.9639 5.47404 26.7607 5.27088Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangUp);
export default __webpack_public_path__ + "static/media/hang_up.ca9018ca.svg";
export { ForwardRef as ReactComponent };